export default __webpack_public_path__ + "static/media/img_4.a0725d74.jpg";